type Settings = {
  DS_RECORDER_JS_PATH: string;
  EDITOR_BANNER_PATH: string;
  EDITOR_PLAYER_PATH: string;
  EDITOR_RUNTIME_PATH: string;
  CUSTOM_MODULES: boolean;
  API_DOMAIN: string;
  TABLE_CRAFT_DOMAIN: string;
  ANALYTICS_DEMOSTACK_API: string;
  RECORDER_URL: string;
  WEB_APP: string;
  EDITOR_BASE_URL: string;
  TOURS_BASE_URL: string;
  FILES_SERVICE_URL: string;
  RECORDER_JS_BASE_URL: string;
  SEGMENT_KEY: string;
  SEGMENT_SOURCE: string;
  KEYGEN_LICENSE: string;
  DS_CLEAR_USER_DATA_CACHE: boolean;
  X_DESKTOP_API_KEY: string;
  ANALYTICS_DEMOSTACK_API_KEY: string;
  LDKEY: string;
  IS_PROD?: boolean;
  LOGROCKET_APP_ID?: string;
  OKTA_CLIENT_ID: string;
  OKTA_ISSUER: string;
  MENTAT_DOMAIN: string;
  ENCRYPT_STORAGE_KEY?: string;
  BOOST_ENCRYPT_STORAGE_KEY?: string;
  DEEPLINK_PROTOCOL: string;
  DD_CLIENT_API_KEY: string;
  USE_LOCAL_EDITOR: boolean;
  npm_package_version: string;
  DD_LOGS_SEND_RENDERER_LOCAL_LOGS: boolean;
  BOOST_DISK_SPACE_LIMIT: number;
  BUNDLE_ID: string;
  OP_SERVICE_ACCOUNT_TOKEN: string;
  DESKTOP_SHOWTIME_URL: string;
  // Add ENV vars to webpack.config.base.ts
};

export const settings: Settings = {
  DS_RECORDER_JS_PATH: process.env.DS_RECORDER_JS_PATH || '',
  EDITOR_BANNER_PATH: process.env.EDITOR_BANNER_PATH || '',
  EDITOR_PLAYER_PATH: process.env.EDITOR_PLAYER_PATH || '',
  EDITOR_RUNTIME_PATH: process.env.EDITOR_RUNTIME_PATH || '',
  CUSTOM_MODULES: process.env.CUSTOM_MODULES === 'true',
  API_DOMAIN: process.env.API_DOMAIN || '',
  TABLE_CRAFT_DOMAIN: process.env.TABLE_CRAFT_DOMAIN || '',
  ANALYTICS_DEMOSTACK_API: process.env.ANALYTICS_DEMOSTACK_API || '',
  RECORDER_URL: process.env.RECORDER_URL || '',
  WEB_APP: process.env.WEB_APP || '',
  EDITOR_BASE_URL: process.env.EDITOR_BASE_URL || '',
  TOURS_BASE_URL: process.env.TOURS_BASE_URL || '',
  FILES_SERVICE_URL: process.env.FILES_SERVICE_URL || '',
  RECORDER_JS_BASE_URL: process.env.RECORDER_JS_BASE_URL || '',
  SEGMENT_KEY: process.env.SEGMENT_KEY || '',
  SEGMENT_SOURCE: process.env.SEGMENT_SOURCE || '',
  KEYGEN_LICENSE: process.env.KEYGEN_LICENSE || '',
  DS_CLEAR_USER_DATA_CACHE: process.env.DS_CLEAR_USER_DATA_CACHE === 'true',
  X_DESKTOP_API_KEY: process.env.X_DESKTOP_API_KEY || '',
  ANALYTICS_DEMOSTACK_API_KEY: process.env.ANALYTICS_DEMOSTACK_API_KEY || '',
  LDKEY: process.env.LDKEY || '',
  IS_PROD: process.env.IS_PROD === 'true',
  LOGROCKET_APP_ID: process.env.LOGROCKET_APP_ID,
  OKTA_CLIENT_ID: process.env.OKTA_CLIENT_ID || '',
  OKTA_ISSUER: process.env.OKTA_ISSUER || '',
  MENTAT_DOMAIN: process.env.MENTAT_DOMAIN || '',
  ENCRYPT_STORAGE_KEY: process.env.ENCRYPT_STORAGE_KEY,
  BOOST_ENCRYPT_STORAGE_KEY: process.env.BOOST_ENCRYPT_STORAGE_KEY,
  DEEPLINK_PROTOCOL: process.env.DEEPLINK_PROTOCOL || '',
  DD_CLIENT_API_KEY: process.env.DD_CLIENT_API_KEY || '',
  USE_LOCAL_EDITOR: process.env.USE_LOCAL_EDITOR === 'true',
  npm_package_version: process.env.npm_package_version || '',
  DD_LOGS_SEND_RENDERER_LOCAL_LOGS:
    process.env.DD_LOGS_SEND_RENDERER_LOCAL_LOGS === 'true',
  BOOST_DISK_SPACE_LIMIT: Number(process.env.BOOST_DISK_SPACE_LIMIT),
  BUNDLE_ID: process.env.BUNDLE_ID || '',
  OP_SERVICE_ACCOUNT_TOKEN: process.env.OP_SERVICE_ACCOUNT_TOKEN || '',
  DESKTOP_SHOWTIME_URL: process.env.DESKTOP_SHOWTIME_URL || '',
};
